import React from 'react';
import type { VideoMetadataEntry } from '@jwp/ott-common/src/utils/metadata';

import AgeRatingBadge from '../AgeRatingBadge/AgeRatingBadge';

import styles from './VideoMetaData.module.scss';

type Props = {
  attributes: VideoMetadataEntry[];
  separator?: string;
};

const isAgeRatingEntry = (entry: VideoMetadataEntry): entry is { type: 'ageRating'; label: string } =>
  typeof entry === 'object' && entry !== null && entry.type === 'ageRating';

const VideoMetaData: React.FC<Props> = ({ attributes, separator = '•' }: Props) => {
  return (
    <div>
      {attributes.map((entry, index) => {
        const key = isAgeRatingEntry(entry) ? `age-${entry.label}` : entry;

        return (
          <React.Fragment key={key}>
            {isAgeRatingEntry(entry) ? <AgeRatingBadge label={entry.label} /> : <span>{entry}</span>}
            {index < attributes.length - 1 && (
              <span className={styles.separator} aria-hidden="true">
                {separator}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default VideoMetaData;
